import React from 'react';
import { WagesSection } from './wages';
import { ContractorsSection } from './contractors';
export function urlToSubpage(accountType, pageUrl, type, claimGroup) {
  const urlToSubpageComponent = {
    'wages': () => /*#__PURE__*/React.createElement(WagesSection, {
      page: pageUrl,
      accountType: accountType,
      claimGroup: claimGroup,
      type: type
    }),
    'contractors': () => /*#__PURE__*/React.createElement(ContractorsSection, {
      page: pageUrl,
      accountType: accountType,
      claimGroup: claimGroup,
      type: type
    })
  };
  return urlToSubpageComponent[pageUrl]();
}